import React from 'react';
import Image from '@plone/volto/components/theme/Image/Image';

import {
  ESCALA_MINIATURA,
  getGaleriaImageProps,
  type GaleriaFoto,
} from './helpers';

interface MiniaturaProps {
  foto: GaleriaFoto;
  onSelecionar: (indice: number) => void;
  /** `true` na foto em cartaz — só a grade marca; a trilha nunca mostra a atual. */
  ativa?: boolean;
  /**
   * Verbo do rótulo acessível. Na trilha o clique promove a foto ao palco
   * ("Ver"); na grade ele abre a foto ampliada ("Ampliar"). O nome do botão
   * precisa dizer o que vai acontecer, não só qual foto é.
   */
  verbo?: string;
  className?: string;
}

/**
 * Miniatura clicável, com o número sobreposto. É a mesma peça na trilha e na
 * grade: o que muda entre as duas é só a caixa que a contém.
 */
export const Miniatura: React.FC<MiniaturaProps> = ({
  foto,
  onSelecionar,
  ativa,
  verbo = 'Ver',
  className,
}) => {
  const imageProps = getGaleriaImageProps(foto, ESCALA_MINIATURA);

  return (
    <button
      type="button"
      onClick={() => onSelecionar(foto.indice)}
      aria-label={`${verbo} a foto ${foto.numero}${foto.alt ? `: ${foto.alt}` : ''}`}
      aria-current={ativa ? 'true' : undefined}
      className={`mpf-galeria__thumb ${className ?? ''}`.trim()}
    >
      {imageProps && (
        <Image
          {...imageProps}
          alt=""
          /* `alt=""`: o nome acessível do botão já descreve a foto. Repetir a
             descrição na imagem faria o leitor de tela ler tudo duas vezes. */
          loading="lazy"
          decoding="async"
          className="mpf-galeria__thumb-img"
        />
      )}
      <span aria-hidden="true" className="mpf-galeria__thumb-numero">
        {foto.numero}
      </span>
    </button>
  );
};

export default Miniatura;
